export function formatDate(isoString) {
	const date = new Date(isoString);

	const dateOptions = { day: "2-digit", month: "2-digit", year: "numeric" };
	const timeOptions = {
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: true,
	};

	const formattedDate = date.toLocaleDateString("en-US", dateOptions);
	const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

	return { formattedDate, formattedTime };
}

export function formatDateString(isoString) {
	if (isoString === null) return "N/A";
	const date = new Date(isoString);

	const dateOptions = {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	};
	const timeOptions = {
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: true,
	};

	const formattedDate = date.toLocaleDateString("en-US", dateOptions);
	const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

	return `${formattedDate} ${formattedTime}`;
}

export function toLocalISOString(date) {
	const offsetMs = date.getTimezoneOffset() * 60 * 1000;
	const localTime = new Date(date.getTime() - offsetMs);
	return localTime.toISOString();
}

export const getformatTime = (timestamp) => {
	const date = new Date(timestamp);
	let hours = date.getHours();
	const minutes = date.getMinutes();
	const ampm = hours >= 12 ? "PM" : "AM";
	hours = hours % 12 || 12;
	const formattedTime = `${hours}:${minutes
		.toString()
		.padStart(0, "0")} ${ampm}`;
	return formattedTime;
};
export const getformatDate = (timestamp) => {
	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = date.getMonth() + 1; // Months are 0-based
	const day = date.getDate();
	const formattedDate = `${year}.${month}.${day}`;
	return formattedDate;
};
